<template>
  <div class="page-index">
    <HeroPd8337 />
    <HowItWorksPd8337
      :steps="howItWorksSteps"
      :enter-form-path="enterFormPath"
    />
    <FaqAccordionPd8337
      :faq-items="faqItems"
      :enter-form-path="enterFormPath"
    />
  </div>
</template>

<script>
import FaqAccordionPd8337 from '~/components/FaqAccordion.PD-8337.vue'
import HowItWorksPd8337 from '~/components/HowItWorks.PD-8337.vue'
import HeroPd8337 from '~/components/Hero.PD-8337.vue'

export default {
  components: {
    HeroPd8337,
    HowItWorksPd8337,
    FaqAccordionPd8337,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      enterFormPath: '/offertes-aanvragen/start',
      howItWorksSteps: [
        {
          id: 1,
          number: 1,
          iconPlaceholder: '📝',
          title:
            'Geef aan of je wilt kopen of verkopen en beantwoord een paar vragen over je woning.',
          description:
            'Zo kunnen makelaars je beter helpen bij je zoektocht of verkoop.',
        },
        {
          id: 2,
          number: 2,
          iconPlaceholder: '📞',
          title: 'Wij matchen je met geschikte makelaars bij jou in de buurt.',
          description:
            'Zij nemen contact met je op of je kunt zelf bellen, net wat jij prettig vindt.',
        },
        {
          id: 3,
          number: 3,
          iconPlaceholder: '🏠',
          title:
            'Ontmoet makelaars bij jou thuis of bij het huis dat je wilt kopen.',
          description:
            'Vergelijk hun aanbod en kies de makelaar die het beste bij je past.',
        },
        {
          id: 4,
          number: 4,
          iconPlaceholder: '✅',
          title:
            'Ontvang vrijblijvend een offerte voor de aankoop of verkoop van je woning.',
          description:
            'Deze offerte is altijd afgestemd op jouw persoonlijke wensen.',
        },
      ],
      faqItems: [
        {
          id: 1,
          question: 'Waarom moet ik mijn contactgegevens toevoegen?',
          answer:
            'De makelaars hebben je contactgegevens nodig om contact met je op te nemen. Dit stelt hen in staat om je behoeften te begrijpen en je een passende offerte te bieden. Door je gegevens te verstrekken, kunnen de makelaars jou direct benaderen voor meer informatie over je wensen, zoals het type woning dat je zoekt of verkoopt, en de diensten die ze kunnen aanbieden. Dit zorgt ervoor dat je snel en efficiënt geholpen wordt, en dat je op maat gemaakte aanbiedingen ontvangt die passen bij jouw situatie.',
        },
        {
          id: 2,
          question: 'Kan ik kiezen met welke makelaar ik wil samenwerken?',
          answer:
            'Ja, absoluut. Nadat je je aanvraag via Makelaarwijzer.nl hebt ingediend, ontvang je reacties of offertes van meerdere makelaars. Je bent volledig vrij om deze voorstellen te vergelijken en zelf te beslissen met welke makelaar je eventueel verder wilt gaan. Er is geen enkele verplichting om voor een van de aangedragen makelaars te kiezen. Jij bepaalt zelf wie het beste bij jouw wensen past.',
        },
        {
          id: 3,
          question:
            'Zijn er kosten verbonden aan het gebruik van de diensten van Makelaarwijzer.nl?',
          answer:
            'Nee, het gebruik van Makelaarwijzer.nl is voor jou als aanvrager volledig gratis en vrijblijvend. Je kunt kosteloos offertes of voorstellen van makelaars ontvangen en vergelijken zonder enige verplichting.',
        },
        {
          id: 4,
          question: 'Hoe ontvang ik offertes van makelaars?',
          answer:
            'Nadat je je aanvraag hebt ingediend op Makelaarwijzer.nl, sturen wij deze door naar relevante makelaars in jouw regio. Deze makelaars nemen vervolgens rechtstreeks contact met je op, meestal via e-mail of telefoon, om hun diensten toe te lichten en je een (vrijblijvende) offerte of voorstel te doen. Zorg er daarom voor dat je contactgegevens correct zijn ingevuld.',
        },
        {
          id: 5,
          question:
            'Hoe kan ik zeker zijn van de kwaliteit van de makelaars die worden weergegeven?',
          answer:
            'Makelaarwijzer.nl streeft ernaar samen te werken met gekwalificeerde en betrouwbare makelaars. Vaak zijn dit kantoren die zijn aangesloten bij brancheverenigingen zoals NVM, VBO of Vastgoedpro. We raden je echter altijd aan om zelf ook de makelaars te beoordelen. Kijk naar hun ervaring, lees online reviews, en voer een kennismakingsgesprek om te bepalen of er een goede klik is en of de makelaar aan jouw verwachtingen voldoet.',
        },
        {
          id: 6,
          question:
            'Kan ik mijn gegevens laten verwijderen na het vinden van een match?',
          answer:
            'Ja, dat is mogelijk. Conform de privacywetgeving (AVG) heb je het recht om je persoonsgegevens in te zien, te corrigeren of te laten verwijderen uit onze systemen. Je kunt hiervoor contact opnemen met Makelaarwijzer.nl via onze contactgegevens. Houd er wel rekening mee dat makelaars die jouw gegevens al hebben ontvangen via je aanvraag, zelf verantwoordelijk zijn voor het beheer van die gegevens volgens hun eigen privacybeleid.',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.PD-8337__variant {
  .navbar {
    @apply absolute bg-transparent text-white border-b-0 container;

    .navbar__container {
      @apply flex items-center justify-center md:justify-between;
    }

    .navbar__logo {
      @apply text-white;
    }
  }
}
</style>
